import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import { ContainedButton } from 'components/core/Button';

const BaseButton = ({ labelId, ...otherProps }) => (
  <ContainedButton
    label={labelId ? <LocalizedMessage id={labelId} /> : null}
    {...otherProps}
  />
);

BaseButton.propTypes = {
  labelId: PropTypes.string,
};

BaseButton.defaultProps = {
  labelId: null,
};

export const ActivateSimcardsContainedButton = (props) => <BaseButton iconId="btnSimcard" labelId="button.activateSimcards" {...props} />;
export const AddAccessRightContainedButton = (props) => <BaseButton iconId="btnAddRight" labelId="button.addAccessRight" {...props} />;
export const AddContainedButton = (props) => <BaseButton iconId="btnAdd" labelId="button.add" {...props} />;
export const RefundContainedButton = (props) => <BaseButton labelId="button.refundPurchases" {...props} />;
export const CarparksContainedButton = (props) => <BaseButton labelId="button.carparks" {...props} />;
export const DownloadArchiveContainedButton = (props) => <BaseButton iconId="btnDownloadArchive" labelId="button.downloadArchive" {...props} />;
export const PingContainedButton = (props) => <BaseButton iconId="btnPing" labelId="button.ping" {...props} />;
export const RebootContainedButton = (props) => <BaseButton iconId="btnReboot" labelId="button.reboot" {...props} />;
export const ResetContainedButton = (props) => <BaseButton iconId="btnReset" labelId="button.reset" {...props} />;
export const SyncContainedButton = (props) => <BaseButton iconId="btnSync" labelId="button.synchronize" {...props} />;
export const TriggerContainedButton = (props) => <BaseButton iconId="btnTrigger" labelId="button.trigger" {...props} />;
export const TriggerDoorContainedButton = (props) => <BaseButton iconId="btnOpenDoor" labelId="button.open" {...props} />;
export const BackContainedButton = (props) => <BaseButton iconId="btnBack" labelId="button.back" {...props} />;
export const BackToCarparksContainedButton = (props) => <BaseButton iconId="btnBack" labelId="button.backToCarparks" {...props} />;
export const SendPaymentLinkContainedButton = (props) => <BaseButton iconId="btnEmail" labelId="button.sendPaymentLink" {...props} />;
export const RefundPurchaseContainedButton = (props) => <BaseButton labelId="button.refundThisPurchase" {...props} />;
// Warning button
export const WarningContainedButton = (props) => <BaseButton context="warning" {...props} />;



// WEBPACK FOOTER //
// ./components/buttons/ContainedButtons.js